import { 
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
} from '@material-ui/core'
import { useFormik } from "formik";
import React, { useState } from 'react'
import { EncryptStorage } from "encrypt-storage";

function CreateOrUpdateNegativeFacts(props) {
    const { createOrUpdate }                        = props;
    const [open, setOpen]                           = useState(false);
    const encryptStorage                            = new EncryptStorage("secret-key");
    const decypt_data                               = encryptStorage.getItem("client_case_id");  

    const onSubmit = async (values) =>{
        values["client_case_id"]    = decypt_data;
        await createOrUpdate(values);  
        handleClose(); 
    }

    function handleClickOpen() {
        setOpen(true);
    }
    
    function handleClose() {
        setOpen(false);
    }

    const formik = useFormik( 
    {
        initialValues: {  
        },
        validateOnBlur:true,
        onSubmit,
    });

    return(
        <>
            <div className="card-toolbar">
                <Button onClick={handleClickOpen} className={'btn btn-create'}>Create</Button>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Negative facts about other parent</DialogTitle>
                <label className={"MuiDialogTitle-root"}>It is important to make sure your attorney is prepared, and is not surprised by bad facts during your case. For that reason it is important that you disclose all relevant facts in your case, even if some of those facts are difficult to disclose. Remember that no parent is perfect, and all parents have done things they regret. </label>
                <DialogContent>
                <DialogContentText id="alert-dialog-description"> 
                <form onSubmit={formik.handleSubmit}>
                    <div className="form-group row">
                        <div className="col-lg-12 mb-4">
                            <label>Negative facts about other parent</label>
                            <TextField 
                                name="negative_facts"
                                label="Client's Schedule" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.negative_facts}
                                variant={"outlined"}
                                fullWidth={true}  
                            />
                            <br/>
                            <span>
                                {formik.touched.negative_facts &&  formik.errors.negative_facts ? formik.errors.negative_facts:""}
                            </span>
                        </div> 
                        <DialogActions>
                            <Button onClick={handleClose} variant="contained" size="large" color="secondary">
                                Cancel
                            </Button>
                            <Button className="text-white" variant="contained" color="primary" size="large" type="submit" autoFocus>
                                Submit
                            </Button>
                        </DialogActions> 
                    </div>
                </form>  
                </DialogContentText>
                </DialogContent> 
            </Dialog> 
        </>
    )
}

export default CreateOrUpdateNegativeFacts